/*
 * Stub for @react-native-documents/picker for webpack
 * so web builds don't fail. No-op implementation since this
 * is only used on iOS/Android platforms.
 */

// Basic document types
export const types = {
  allFiles: '*/*',
  images: 'image/*',
  zip: 'application/zip',
};

// Error codes
export const errorCodes = {};

// No-op functions
export const pick = async (): Promise<unknown[]> => [];

export const isErrorWithCode = (): boolean => false;

// Default export
export default {
  pick,
  types,
  errorCodes,
  isErrorWithCode,
};
